
<template>
  <div class="pageBox">
    <div class="topNav">
      <div class="backPage" @click="backHome">
        <img src="@/assets/images/jiantou.png">
        返回
      </div>
      <ul>
        <li @click="clickLeft">
          <div class="imgBtn">
            <img src="@/assets/images/leftIcon.png">
          </div>
          <span>左侧</span>
        </li>
        <li @click="clickRight">
          <div class="imgBtn">
            <img src="@/assets/images/rightIcon.png">
          </div>
          <span>右侧</span>
        </li>
        <li @click="redoEvent">
          <div class="imgBtn">
            <img src="@/assets/images/chexiao.png" class="cancelImg">
          </div>
          <span>撤销</span>
        </li>
        <li @click="undoEvent">
          <div class="imgBtn">
            <img src="@/assets/images/fanchexiao.png" class="cancelImg">
          </div>
          <span>反撤销</span>
        </li>
        <li @click="onCheck">
          <div class="imgBtn">
            <img src="@/assets/images/jiancha.png" class="jiancha">
          </div>
          <span>检查</span>
        </li>
        <li @click="onSave">
          <div class="imgBtn">
            <img src="@/assets/images/saveImg.png">
          </div>
          <span>手动保存</span>
        </li>
      </ul>
    </div>
    <div class="flowContainer">
      <div class="leftModlue" v-if="leftFlag">
        <LeftModule />
      </div>
      <div @dragover="dragover" @drop="addNode" class="centerModlue">
        <butterfly-vue ref="butterfly" :linkable="bool" :draggable='bool' className="flowChartBox"
          @clickNode='clickNode' :canvasData="mockData" @onLoaded="finishLoaded" @onCreateEdge='addEdge'
          @onclickEdge='onclickEdge' key="flowChartBox" />
      </div>
      <div class="rightModlue" v-if="rightFlag">
        <!-- 右侧 -->
        <RightModule />
      </div>
    </div>
  </div>
</template>
<script>
import left from "./leftModule/leftModule";
import right from "./rightModule.vue";
import nodeType from "./flowChart/node-type.vue";
import ButterflyVue from "./flowChart/butterfly-vue.vue";
import defaultData from "./flowChart/default-data";
import {
  upDecisionTree,
  decisionTreeDetails,
  upPatientTree,
  patientTreeDetails,
  checkDecisionTree
} from "./api";
import local from "@/utils/local.js";
// import { jsonp } from "vue-jsonp";

export default {
  components: {
    LeftModule: left,
    RightModule: right,
    ButterflyVue,
    nodeType
  },
  data() {
    return {
      bool: true,
      timer: null,
      decisionTreeId: null,
      pageName: null,
      leftFlag: true,
      rightFlag: true,
      curEditeNode: null,
      curEditeEdge: null,
      redoList: [], //撤销列表 5
      undoList: [], //反撤销列表 5
      mockData: {
        nodes: [],
        edges: []
      },
      mockData1: defaultData,
      canvansRef: {},
      butterflyVue: {}
    };
  },
  created() {
    let that = this;

    document.onkeydown = function(e) {
      let key = window.event.keyCode;
      var agent = navigator.userAgent.toLowerCase();
      var isMac = /macintosh|mac os x/i.test(navigator.userAgent);
      //win
      if (
        agent.indexOf("win32") >= 0 ||
        agent.indexOf("wow32") >= 0 ||
        agent.indexOf("win64") >= 0 ||
        agent.indexOf("wow64") >= 0
      ) {
        if (key == 46) {
          that.delEage();
        }
      }
      //mac
      if (isMac) {
        if (key == 8) {
          that.delEage();
        }
      }
    };
    this.mockData.nodes.map(item => {
      item.render = nodeType;
    });
    let decisionTreeObj = localStorage.getItem("decisionTreeObj");
    if (decisionTreeObj) {
      let obj = JSON.parse(decisionTreeObj);
      this.decisionTreeId = obj.decisionTreeId;
      this.pageName = obj.pageName;
      if (this.pageName == "templatePage") {
        this.templateDetails();
      } else {
        this.patientDetails();
      }
    }
  },
  mounted() {
    this.timer = setInterval(this.onSave, 10 * 60 * 1000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    //返回上一页面
    backHome() {
      this.$router.go(-1);
    },
    // 模板详情
    async templateDetails() {
      let res = await decisionTreeDetails(this.decisionTreeId);
      if (res.code == 0 && res.data.treeJson) {
        let data = JSON.parse(res.data.treeJson);
        this.renderTree(data);
      } else {
        this.mockData = {
          nodes: [],
          edges: []
        };
      }
      this.$refs.butterfly.setMinimap();
      local.set("patientSchemeHospitalId", res.data.hospitalId)
    },
    // 患者详情
    async patientDetails() {
      let res = await patientTreeDetails(this.decisionTreeId);
      if (res.code == 0 && res.data.draftTreeJson) {
        let data = JSON.parse(res.data.draftTreeJson);
        this.renderTree(data);
      } else {
        this.mockData = {
          nodes: [],
          edges: []
        };
      }
      this.$refs.butterfly.setMinimap();
      local.set("patientSchemeHospitalId", res.data.hospitalId)
    },
    renderTree(data) {
      let nodes = data.nodes;
      if (nodes.length > 0) {
        nodes.map(item => {
          item.render = nodeType;
          // item.hoverTime = "详情页展示提示";
        });
      }
      this.mockData = {
        nodes: nodes,
        edges: data.edges
      };
    },
    //检查
    async onCheck() {
      let obj = JSON.stringify(this.mockData);
      let params = {
        treeJson: obj
      };
      let res = await checkDecisionTree(params);
      if (res.data) {
        this.$message({
          message: "通过！",
          type: "success"
        });
      }
    },
    //10分钟自动保存
    onSave() {
      //模板列表进入
      if (this.pageName == "templatePage") {
        this.saveTemplate();
      }
      if (this.pageName == "patientPage") {
        this.savePatient();
      }
    },
    //模板逻辑决策树保存
    async saveTemplate() {
      let obj = JSON.stringify(this.mockData);
      let params = {
        id: this.decisionTreeId,
        treeJson: obj
      };
      let res = await upDecisionTree(params);
      if (res.data) {
        this.$message({
          message: "保存成功！",
          type: "success"
        });
      }
    },
    //患者决策树保存
    async savePatient() {
      let obj = JSON.stringify(this.mockData);
      let params = {
        id: this.decisionTreeId,
        draftTreeJson: obj
      };
      let res = await upPatientTree(params);
      if (res.data) {
        this.$message({
          message: "保存成功！",
          type: "success"
        });
      }
    },
    clickLeft() {
      this.leftFlag = !this.leftFlag;
    },
    clickRight() {
      this.rightFlag = !this.rightFlag;
    },
    //点击线
    onclickEdge(data) {
      this.curEditeNode = null;
      this.curEditeEdge = {
        links: [data.edge]
      };
    },
    //点击节点
    clickNode(item) {
      this.curEditeEdge = null;
      this.curEditeNode = item;
    },
    //删除
    delEage() {
      //节点
      if (this.curEditeNode != null) {
        let index = this.mockData.nodes.findIndex(item => {
          return item.id === this.curEditeNode.id;
        });
        if (index >= 0) {
          let result = this.mockData.nodes[index];
          //获取相邻线
          let adjacentEdges = this.canvansRef.getNeighborEdges(
            this.curEditeNode.id
          );
          this.mockData.nodes.splice(index, 1);
          if (adjacentEdges.length > 0) {
            adjacentEdges.map(item => {
              this.mockData.edges.map((items, index) => {
                if (item.id == items.id) {
                  //删除节点时删除节点的相邻线,否则撤销的时候连线无起时节点
                  this.mockData.edges.splice(index, 1);
                }
              });
            });
          }
          let reObj = {
            type: "system:removeNodes",
            data: result,
            adEdges: adjacentEdges
          };
          this.pushReData(reObj);
        }
        // this.canvansRef.removeNodes([this.curEditeNode.id]);
        this.curEditeNode = null;
      }
      //连线
      if (this.curEditeEdge != null) {
        let index = this.mockData.edges.findIndex(item => {
          return item.id === this.curEditeEdge.links[0].id;
        });
        if (index >= 0) {
          let result = this.mockData.edges[index];
          this.mockData.edges.splice(index, 1);
          let reObj = {
            type: "system:removeEdges",
            data: result
          };
          this.pushReData(reObj);
        }
        // this.$refs.butterfly.onDeleteEdge(this.curEditeEdge); //调用组件删除线方法
        this.curEditeEdge = null;
      }
    },
    //撤销
    redoEvent() {
      if (this.redoList.length > 0) {
        let cur = this.redoList.pop();
        if (cur.type == "system:addEdges") {
          let index = this.mockData.edges.findIndex(item => {
            return item.id === cur.data.id;
          });
          if (index >= 0) {
            this.mockData.edges.splice(index, 1);
          }
        }
        if (cur.type == "system:addNodes") {
          let index = this.mockData.nodes.findIndex(item => {
            return item.id === cur.data.id;
          });
          if (index >= 0) {
            this.mockData.nodes.splice(index, 1);
          }
        }
        if (cur.type == "system:removeEdges") {
          this.mockData.edges.push(cur.data);
        }
        if (cur.type == "system:removeNodes") {
          this.mockData.nodes.push(cur.data);
          if (cur.adEdges && cur.adEdges.length > 0) {
            cur.adEdges.map(item => {
              this.mockData.edges.push({
                id: item.id,
                source: item.sourceEndpoint.id,
                sourceNode: item.sourceNode.id,
                target: item.targetEndpoint.id,
                targetNode: item.targetNode.id
              });
            });
          }
        }
        this.pushUnData(cur);
      } else {
        this.$message({
          message: "当前状态不能撤销",
          type: "warning",
          duration: 2000
        });
      }
    },
    //反撤销
    undoEvent() {
      if (this.undoList.length > 0) {
        //获取最后一个元素
        let cur = this.undoList.pop();
        if (cur.type == "system:addNodes") {
          this.mockData.nodes.push(cur.data);
        }
        if (cur.type == "system:addEdges") {
          this.mockData.edges.push(cur.data);
        }
        if (cur.type == "system:removeEdges") {
          let index = this.mockData.edges.findIndex(item => {
            return item.id === cur.data.id;
          });
          if (index >= 0) {
            this.mockData.edges.splice(index, 1);
          }
        }
        if (cur.type == "system:removeNodes") {
          let index = this.mockData.nodes.findIndex(item => {
            return item.id === cur.data.id;
          });
          if (index >= 0) {
            this.mockData.nodes.splice(index, 1);
          }
          if (cur.adEdges && cur.adEdges.length > 0) {
            cur.adEdges.map(item => {
              this.mockData.edges.map((items, index) => {
                if (item.id == items.id) {
                  //删除节点时删除节点的相邻线,否则撤销的时候连线无起时节点
                  this.mockData.edges.splice(index, 1);
                }
              });
            });
          }
        }
        this.pushReData(cur);
      } else {
        this.$message({
          message: "当前状态不能反撤销",
          type: "warning",
          duration: 2000
        });
      }
    },
    dragover(e) {
      e.preventDefault();
    },
    //获取目标数据下标
    getIndex(list, id) {
      return list.findIndex(item => {
        return item.id === id;
      });
    },
    addEdge(obj) {
      // debugger;
      let edgeId = obj.id;
      let sourceId = obj.sourceNode;
      let targetId = obj.targetNode;
      let nodeList = this.mockData.nodes;
      let edgeList = this.mockData.edges;
      //起始节点
      let sourceNodeIndex = this.getIndex(nodeList, sourceId);
      //目标节点
      let targetNodeIndex = this.getIndex(nodeList, targetId);
      if (
        nodeList[sourceNodeIndex].nodeType == 1 &&
        nodeList[targetNodeIndex].nodeType == 4
      ) {
        this.$message({
          message: "术语不可连接通知框！",
          type: "warning"
        });
        let edgeIndex = this.getIndex(edgeList, edgeId);
        edgeList.splice(edgeIndex, 1);
        return;
      }
      //
      if (nodeList[sourceNodeIndex].nodeType == 2) {
        if (
          nodeList[targetNodeIndex].nodeType != 2 &&
          nodeList[targetNodeIndex].nodeType != 4
        ) {
          // debugger;
          this.$message({
            message: "编链类、其他类只可连接通知框或者其他同类框",
            type: "warning"
          });
          let edgeIndex = this.getIndex(edgeList, edgeId);
          edgeList.splice(edgeIndex, 1);
          return;
        }
      }
      //
      let reObj = {
        type: "system:addEdges",
        data: obj
      };
      this.pushReData(reObj);
    },
    addNode(e) {
      // debugger
      let { clientX, clientY } = e;
      let coordinates = this.canvansRef.terminal2canvas([clientX, clientY]);
      if (!e.dataTransfer.getData("user")) {
        return;
      }
      let user = JSON.parse(e.dataTransfer.getData("user"));
      let result = {
        id: this.guid(),
        left: coordinates[0],
        top: coordinates[1],
        render: nodeType,
        nodeType: user.nodeType,
        img: true
      };
      //nodeType 1:输入; 2:输出; 3:条件; 4:通知 testName:自定义标识
      //输入类型
      if (user.nodeType == 1) {
        result.fieldName = user.fieldLabel; //1
        result.fieldCode = user.fieldCode; //1
        result.fieldLabel = user.fieldName;
        result.fieldValue = user.fieldValue;
        result.endpoints = [
          //设置4个锚点
          {
            id: "top",
            orientation: [0, -1] //上: [0,-1] 下: [0,1] 左: [-1,0] 右: [1,0]
            //pos: [0.5, 0] // 锚点位置 [0-1之间 , 0-1之间]，0代表最左/上侧，1代表最右/下侧
          },
          // {
          //   id: "right",
          //   orientation: [1, 0]
          // },
          {
            id: "bottom",
            orientation: [0, 1]
          }
          // {
          //   id: "left",
          //   orientation: [-1, 0]
          // }
        ];
      }
      //输出|| 文本类型
      if (user.nodeType == 2) {
        result.outputType = user.outputType; //1：文本,2：问卷,3：宣教,4：编链
        result.outputContent = user.outputContent;
        result.endpoints = [
          //设置4个锚点
          {
            id: "top",
            orientation: [0, -1] //上: [0,-1] 下: [0,1] 左: [-1,0] 右: [1,0]
            //pos: [0.5, 0] // 锚点位置 [0-1之间 , 0-1之间]，0代表最左/上侧，1代表最右/下侧
          },
          {
            id: "right",
            orientation: [1, 0]
          },
          {
            id: "bottom",
            orientation: [0, 1]
          },
          {
            id: "left",
            orientation: [-1, 0]
          }
        ];
        //4:编链
        if (user.outputType == 4) {
          let tar = user.displayContent;
          //8健康问卷
          if (tar.itemType == 8) {
            result.displayContent = tar.courseName;
            result.itemName = tar.courseName;
          } else {
            result.displayContent = tar.itemName;
            result.itemName = tar.itemName;
          }
          result.cycleStr = tar.cycleStr;
          if (tar.attrs == 1) {
            result.attrs = "长期";
          } else {
            result.attrs = tar.shortDays + tar.shortDaysType;
          }
          result.useDosageName = tar.useDosageName;
          result.startTimeType = this.handleTimeType(tar.startTimeType);
          result.startIntervalTime =
            tar.startIntervalTime + tar.startIntervalType;
        } else {
          result.displayContent = user.displayContent;
        }
      }
      //3:条件
      if (user.nodeType == 3) {
        let child = user.children;
        let value = ""; //输入框值
        let valueUnit = "";
        let operator = "";
        //conditionType 1: "时间类型"，2: "定量类型"，3: "定性类型"，
        //4: "绝对类型"，5: "最后次数"，6："间隔时间"，7：持续时间 8： "问卷分值"
        if (user.conditionType == 1) {
          child.map(item => {
            if (item.showType == "input") {
              value = item.value;
            }
            if (item.showType == "select_time") {
              valueUnit = item.valueUnit;
            }
            if (item.showType == "select_time_direction") {
              operator = item.operator;
            }
          });
        }
        if (user.conditionType == 2) {
          child.map(item => {
            if (item.showType == "input") {
              value = item.value;
            }
            if (item.showType == "select_time_longness") {
              valueUnit = item.valueUnit;
            }
            if (item.showType == "select_greater") {
              operator = item.operator;
            }
          });
        }
        if (user.conditionType == 3) {
          child.map(item => {
            if (item.showType == "select_symbol") {
              value = item.value;
              operator = item.operator;
            }
          });
        }
        if (user.conditionType == 4) {
          child.map(item => {
            if (item.showType == "select_bool") {
              operator = item.operator;
            }
          });
        }
        if (user.conditionType == 5) {
          child.map(item => {
            if (item.showType == "button_last") {
              operator = item.value;
            }
            if (item.showType == "select_number") {
              value = item.value;
            }
            if (item.showType == "button") {
              valueUnit = item.value;
            }
          });
        }
        if (user.conditionType == 6) {
          child.map(item => {
            if (item.showType == "select_greater") {
              operator = item.operator;
            }
            if (item.showType == "select_number") {
              value = item.value;
            }
            if (item.showType == "button") {
              valueUnit = item.value;
            }
          });
        }
        if (user.conditionType == 7) {
          child.map(item => {
            if (item.showType == "input") {
              value = item.value;
            }
            if (item.showType == "select_time") {
              valueUnit = item.valueUnit;
            }
          });
        }
        if (user.conditionType == 8) {
          child.map(item => {
            if (item.showType == "input_number") {
              value = item.value;
            }
            if (item.showType == "select_button") {
              valueUnit = item.valueUnit;
            }
            if (item.showType == "select_greater") {
              operator = item.operator;
            }
          });
        }
        result.testName = user.name;
        result.conditionType = user.conditionType;
        result.value = value;
        result.valueUnit = valueUnit;
        result.operator = operator;
        result.endpoints = [
          //设置4个锚点
          {
            id: "top",
            orientation: [0, -1], //上: [0,-1] 下: [0,1] 左: [-1,0] 右: [1,0]
            pos: [0.52, 0] // 锚点位置 [0-1之间 , 0-1之间]，0代表最左/上侧，1代表最右/下侧
          },
          {
            id: "right",
            orientation: [1, 0]
          },
          {
            id: "bottom",
            orientation: [0, 1],
            pos: [0.52, 0]
          },
          {
            id: "left",
            orientation: [-1, 0]
          }
        ];
      }
      //通知类型
      if (user.nodeType == 4) {
        console.log(user,"user");
        let showCon = "";
        if (user.notifyRole == 1) {
          showCon = "个案管理师、患者";
        } else if (user.notifyRole == 2) {
          showCon = "个案管理师";
        }else if(user.notifyType == 10){
          showCon = user.fieldName
        } else {
          showCon = "患者";
        }
        result.notifyRole = user.notifyRole; //1： 所有人;2： 个案管理师;3 ：患者
        result.notifyType = user.notifyType; //1：全病程IM房，2：短信
        result.testName = "通知类型";
        result.showCon = showCon;
        result.refId = user.refId;
        result.endpoints = [
          {
            id: "top",
            orientation: [0, -1], //上: [0,-1] 下: [0,1] 左: [-1,0] 右: [1,0]
            type: "target" //设置为目标锚点
          }
        ];
      }
      let reObj = {
        type: "system:addNodes",
        data: result
      };
      this.pushReData(reObj);
      this.mockData.nodes.push(result);
    },
    handleTimeType(val) {
      if (val == 3) {
        return "入案时间";
      } else if (val == "1") {
        return "服务开始时间";
      } else if (val == "5") {
        return "首次入院时间";
      } else if (val == "6") {
        return "首次手术时间";
      } else if (val == "7") {
        return "首次出院时间";
      } else if (val == "8") {
        return "线上随访时间";
      } else if (val == "4") {
        return "线上问诊时间";
      } else if (val == "9") {
        return "线下随访时间";
      } else if (val == "10") {
        return "服务结束时间";
      }
    },
    //记录撤销数据
    pushReData(obj) {
      if (this.redoList.length < 10) {
        this.redoList.push(obj);
      } else {
        this.redoList.shift();
        this.redoList.push(obj);
      }
    },
    //记录反撤销数据
    pushUnData(obj) {
      if (this.undoList.length < 10) {
        this.undoList.push(obj);
      } else {
        this.undoList.shift();
        this.undoList.push(obj);
      }
    },
    finishLoaded(VueCom) {
      this.butterflyVue = VueCom;
      this.canvansRef = VueCom.canvas;
      window.butterflyVue = VueCom;
      // this.canvansRef.zoom(0.4,{
      // })
    },
    //生成节点唯一标识
    guid() {
      function S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
      }
      return S4() + S4() + "-" + S4();
    }
  }
};
</script>
<style>
.pageBox {
  background: #f8f8f8;
}
.flowChartBox {
  overflow: hidden;
  height: 100%;
}

.butterflie-circle-endpoint {
  cursor: crosshair;
}
.butterflies-link:hover,
.butterflies-link-event-handler:hover {
  stroke: #abc2e2;
  opacity: 0.5;
  stroke-width: 4px;
  cursor: pointer;
}
</style>
<style lang="less" scoped>
.topNav,
.topNav {
  display: flex;
  height: 66px;
  background: #fff;
  margin-bottom: 16px;
  position: relative;
  -moz-user-select: none; /*火狐*/
  -webkit-user-select: none; /*webkit浏览器*/
  -ms-user-select: none; /*IE10*/
  -khtml-user-select: none; /*早期浏览器*/
  user-select: none;
  .backPage {
    width: 53px;
    height: 30px;
    background: #e9f2ff;
    border-radius: 15px;
    position: absolute;
    left: 38px;
    top: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #1a7bfc;
    cursor: pointer;
    img {
      width: 7px;
      height: 11px;
      margin-right: 7px;
    }
  }
}
.topNav ul {
  width: 40%;
  margin: auto;
  display: flex;
  align-content: center;
  justify-content: space-between;
}
.topNav li {
  flex: 1;
  .imgBtn {
    width: 30px;
    height: 30px;
    background: #1a7bfc;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: auto;
    img {
      width: 16px;
      height: 16px;
    }
    .cancelImg {
      width: 19px;
      height: 16px;
    }
    .jiancha {
      width: 14px;
      height: 17px;
    }
  }
  span {
    display: block;
    width: 100%;
    text-align: center;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    margin-top: 7px;
  }
  cursor: pointer;
}
.flowContainer {
  overflow: hidden;
  display: flex;
  height: calc(100vh - 98px);
  .leftModlue,
  .centerModlue,
  .rightModlue {
    background: #fff;
    height: 100%;
  }

  .leftModlue {
    width: 245px;
  }
  .rightModlue {
    width: 245px;
  }
  .centerModlue {
    flex: 1;
    margin: 0 16px;
    overflow: hidden;
    position: relative;
  }
}
</style>
